import { useState } from "react";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";

export default function AuthCard() {
  const [isFlipped, setIsFlipped] = useState(false);

  return (
    <section
      className="relative mx-auto w-full max-w-md"
      style={{ perspective: "1000px" }}
      aria-live="polite"
      aria-label={isFlipped ? "Formulario de registro" : "Formulario de inicio de sesión"}
      data-testid="auth-card"
    >
      <div
        className={[
          "relative min-h-[560px] sm:min-h-[600px] md:min-h-[640px] w-full transition-transform duration-700 ease-in-out motion-reduce:transition-none",
          "transform-gpu will-change-transform [transform-style:preserve-3d]",
          isFlipped ? "[transform:rotateY(180deg)]" : "[transform:rotateY(0deg)]",
        ].join(" ")}
      >
        <div
          className="absolute inset-0 [backface-visibility:hidden]"
          aria-hidden={isFlipped}
        >
          <LoginForm onRequestAccess={() => setIsFlipped(true)} />
        </div>

        <div
          className="absolute inset-0 [backface-visibility:hidden] [transform:rotateY(180deg)]"
          aria-hidden={!isFlipped}
        >
          <RegisterForm onBackToLogin={() => setIsFlipped(false)} />
        </div>
      </div>
    </section>
  );
}
